// extracted by mini-css-extract-plugin
module.exports = {"startNewButton":"src-containers-Project-Detail-Proposals-styles___startNewButton"};